import React, { useEffect, useState } from 'react';
import {
  getModules,
  createModule
} from '../service';
import { SETTINGS_MOCK } from '../constants';
import { handleAPIError } from '../../../utils/apiUtils';

const useModuleState = () => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchModules = async () => {
    try {
      setLoading(true);
      const data = await getModules();
      setModules(data);
    } catch (error) {
      console.error('Failed to fetch modules', error);
      // setModules(SETTINGS_MOCK);
    } finally {
      setLoading(false);
    }
  };

  const sortAndSetModules = (modulesList) => {
    modulesList.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    setModules(modulesList);
  }

  const addOrUpdate = async (module) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      const created = await createModule(module);
      const createdModule = [...modules, created];
      sortAndSetModules(createdModule);
      response.success = true;
      fetchModules();
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add module', error);
    }
    return response;
  };

  useEffect(() => {
    fetchModules();
  }, []);

  return { modules, loading, addOrUpdate };
};

export default useModuleState;
